import React, { useState, useEffect } from "react";
import {
  Dialog,
  Button,
  DialogActions,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
} from "@material-ui/core";
import { SourcesTable } from "./SourcesTable";
import { ISource } from "../../core/redux/dataMap/source";
import { SearchField } from "../../components/SearchField";
import useLanguage from "../../hooks/useLanguage";

interface ISourcesModalProps {
  sources: ISource[];
  show: boolean;
  onHide(): void;
  isAllChecked: boolean;
  isLoading: boolean;
  updateUserSource(source: ISource): void;
  toggleAllSources(): void;
}

export const SourcesModal: React.FC<ISourcesModalProps> = ({
  sources,
  show,
  onHide,
  isAllChecked,
  isLoading,
  updateUserSource,
  toggleAllSources,
}) => {
  const [searchName, setSearchName] = useState("");
  const [filteredSources, setFilteredSources] = useState(sources);
  const { language } = useLanguage();
  const { translate } = language;

  useEffect(() => {
    setFilteredSources(sources);
  }, [sources]);

  const filterSources = (searchNameValue) => {
    setFilteredSources(
      sources.filter((source) =>
        source.name
          .toLocaleLowerCase()
          .includes(searchNameValue.toLocaleLowerCase())
      )
    );
    setSearchName(searchNameValue);
  };

  const submitFilterSources = () => {
    setFilteredSources(
      sources.filter((source) =>
        source.name.toLocaleLowerCase().includes(searchName.toLocaleLowerCase())
      )
    );
  };
  return (
    <Dialog open={show} onClose={onHide} maxWidth="lg" fullWidth>
      <DialogTitle id="form-dialog-title">{translate.source}</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item>
            <SearchField
              label={translate.simple_search_placeholder}
              value={searchName}
              onChange={(value) => filterSources(value)}
              onSubmit={submitFilterSources}
              color={false}
            />
          </Grid>
        </Grid>
        <SourcesTable
          sources={filteredSources}
          isAllChecked={isAllChecked}
          isLoading={isLoading}
          updateUserSource={updateUserSource}
          toggleAllSources={toggleAllSources}
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onHide}>
          Cancel
        </Button>
        {/* <Button color="primary" type="submit">
          Updade
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};
